export default "https://cdn-static.gokick.com/assets/24c3578bda803cdf114b208e53f44151315faa60/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";